import React, { useReducer, useContext } from 'react';
import reducer from '../state/reducer';
import { PropTypes } from 'prop-types';
import uuidv4 from 'uuid/v4';

export let initialState = {
  language: 'fr',
  happening: null,
  coolfooder: {
    uuid: window._uuid || uuidv4(),
    firstname: window._firstname || '',
    lastname: '',
    email: '',
    phone: '',
    postalCode: '',
    allowContactFromCoolfood: true,
    subscribeToNewsletter: false,
    password: '',
    passwordConfirm: '',
    auth_hash: '',
    commitsAlreadyTaken: [], // From current coolfood database
  },
  selectedCommitments: [],
  commits: [],
  commitsValidated: false,
  numberOfBeneficiaries: null,
  carouselSlidable: true,
  currentSlide: 0,
  commitmentModal: null,
  screenContent: '',
  helpContent: ''
};

const CoolfoodContext = React.createContext(initialState);

export default function Store({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const val = [state, dispatch];
  return (
    <CoolfoodContext.Provider value={val}>{children}</CoolfoodContext.Provider>
  );
}

Store.propTypes = {
  children: PropTypes.node
};

export const useCoolfoodContext = () => {
  return useContext(CoolfoodContext);
};
